var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wgu-module-card',_vm._b({staticClass:"sample-module",attrs:{"moduleName":"sample-module","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('v-card-text',[_c('b',[_vm._v("Zoom:")]),_vm._v(" "+_vm._s(_vm.zoom)+" "),_c('br'),_c('b',[_vm._v("Center:")]),_vm._v(" "+_vm._s(_vm.center)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }